import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Role\GetRoleByIdController::__invoke
* @see app/Http/Controllers/Role/GetRoleByIdController.php
* @route '/api/role/{role}'
*/
const GetRoleByIdController = (args: { role: string | { id: string } } | [role: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetRoleByIdController.url(args, options),
    method: 'get',
})

GetRoleByIdController.definition = {
    methods: ["get","head"],
    url: '/api/role/{role}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Role\GetRoleByIdController::__invoke
* @see app/Http/Controllers/Role/GetRoleByIdController.php
* @route '/api/role/{role}'
*/
GetRoleByIdController.url = (args: { role: string | { id: string } } | [role: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { role: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { role: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            role: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        role: typeof args.role === 'object'
        ? args.role.id
        : args.role,
    }

    return GetRoleByIdController.definition.url
            .replace('{role}', parsedArgs.role.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Role\GetRoleByIdController::__invoke
* @see app/Http/Controllers/Role/GetRoleByIdController.php
* @route '/api/role/{role}'
*/
GetRoleByIdController.get = (args: { role: string | { id: string } } | [role: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetRoleByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Role\GetRoleByIdController::__invoke
* @see app/Http/Controllers/Role/GetRoleByIdController.php
* @route '/api/role/{role}'
*/
GetRoleByIdController.head = (args: { role: string | { id: string } } | [role: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetRoleByIdController.url(args, options),
    method: 'head',
})

export default GetRoleByIdController